/* eslint-disable jsx-quotes */
import PropTypes from 'prop-types';
import Head from 'next/head';
import Link from 'next/link';
import { Form, message, Select } from 'antd';
import React, { memo, useEffect, useRef, useState } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import MetaSeo from './MetaSeo';
import axios from 'axios';
import { isIOS } from 'react-device-detect';
import { getAllServices } from '../redux/actions/services';
import { getDisplayName } from 'next/dist/shared/lib/utils';
import useTrans from '../hooks/useTrans';
import Header from './Header';
function Layout({ children, webViewMobile, web }) {
  const [infor, setInfor] = useState();
  const trans = useTrans();
  const dispatch = useDispatch();
  const [service, setService] = useState([]);
  const [show, setShow] = useState(false);
  const [none, setNone] = useState(false);
  const [marginTop, setMarginTop] = useState(0);
  const [show_menu_mobile, setShowMenuMobile] = useState();

  const [show_header, setShowHeader] = useState('sticky');
  const [padding_top, setPaddingTop] = useState('');
  const router = useRouter();
  const [y, setY] = useState(0);
  let positionY = React.useRef(null);
  const refClickLanguage = useRef();
  useEffect(() => {
    localStorage.setItem('lg', router.locale);
    getListServiceAll();
    getInfor(router.locale);
    window.addEventListener('scroll', onScroll);
  }, [router.locale]);

  const getInfor = async locale => {
    await axios
      .get(
        `${process.env.NEXT_PUBLIC_API_SERVER_URL}/app/home/get-list-home-information`,
        {
          headers: {
            'Content-Type': 'application/json',
            locale: locale,
          },
        },
      )
      .then(res => {
        console.log('');
        const data = res.data;
        setInfor(data);
      })
      .catch(error => console.log(error));
  };
  const getListServiceAll = async () => {
    const data = await getAllServices({}, dispatch);
    if (data) {
      setService(data?.rows);
    }
  };

  useEffect(() => {
    let head = document.getElementsByTagName('head')[0];
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    console.log(router);
    if (router.locale === 'en' || router.locale === 'jp') {
      let lisLink = head.querySelector(
        `#${router.locale === 'en' ? 'jp' : 'en'}`,
      );
      if (lisLink) {
        head.removeChild(lisLink);
      }
    }
    if (router.locale === 'vi') {
      let lisLink = head.querySelectorAll(`.newLanguage`);
      console.log(lisLink, 'tes viii');
      if (lisLink.length) {
        head.removeChild(lisLink[0]);
      }
    }
    if (router.locale === 'en') {
      console.log('check EN');
      link.id = 'en';
      link.className = 'newLanguage';
      link.href = '/assets/css/styleEN.css';
    }

    if (router.locale === 'jp') {
      console.log('check JP');
      link.id = 'jp';
      link.className = 'newLanguage';
      link.href = '/assets/css/styleJP.css';
    }
    head.appendChild(link);

    return () => {
      console.log(head);
    };
  }, [router?.locale]);

  const onScroll = e => {
    // let window = e.currentTarget;
    if (!window.vinhY) {
      window.vinhY = 0;
    }
    if (window.pageYOffset > 10) {
      if (window.vinhY > window.pageYOffset) {
        setShowHeader('sticky bgrColor');
      } else if (window.vinhY < window.pageYOffset) {
        setShowHeader('hiddenn');
      }
    } else {
      setShowHeader('sticky');
    }

    window.vinhY = window.pageYOffset;
  };

  let arr = router.components || [];
  let result = arr
    ? Object.keys(router?.components || []).includes('/404')
    : false;

  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <title>Eyefire</title>
        <link rel="shortcut icon" href="/assets/img/logo/favicon.png"></link>
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
        <meta name="theme-color" content="#ffffff"></meta>
      </Head>
      <div id={web}>
        <div id={`header`} className={`${show_header}`}>
          <Header />
        </div>
        <main>{children}</main>
        {/* footer */}
        <div id="footer">
          <footer
            className="l-footer"
            style={{
              backgroundColor:
                router.pathname === '/news/[sort_url]' && !result
                  ? '#fff'
                  : '#001530',
            }}
          >
            {/* <div className="l-footer__contact">
              <div className="l-container">
                {web !== 'contact' ? (
                  <div className="l-footer__contact__inner">
                    <h3>{trans.layout.contact_footer}</h3>
                    <p style={{ padding: '5px', marginBottom: '51px' }}>
                      {trans.layout.content_contact_footer1}
                      <br />
                      {trans.layout.content_contact_footer2}
                    </p>
                    <div className="l-footer__contact__group-btn">
                      <Link href="/contact">
                        <a href="#" className="c-btn">
                          <img
                            src="/assets/img/common/icn_mail.svg"
                            alt=""
                            style={{ marginRight: '5px' }}
                          />
                          {trans.layout.button_contact}
                        </a>
                      </Link>
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div> */}
            <div className="l-footer__content">
              <div className="l-footer__main">
                <div className="l-container-fluid">
                  <div className="l-footer__main__header">
                    <div className="l-footer__main__header__logo">
                      <Link href="/">
                        <a href="#" className="l-footer__main__logo">
                          <img src="/assets/img/common/icn_footer.svg" alt="" />
                        </a>
                      </Link>
                    </div>
                    <div className="l-footer__main__header__slogan">
                      <p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: trans.layout.slogan,
                          }}
                        ></div>
                      </p>
                    </div>
                  </div>

                  <div className="l-row ">
                    <div className="l-col-auto footer-col-menu l-footer__main__office">
                      <h3 className="l-footer__main__title">
                        {trans.layout.office}
                      </h3>
                      <div
                        className="l-footer__main__content"
                        style={{ width: '100%' }}
                      >
                        <div className="l-footer__main__content__item">
                          <h5>{trans.layout.adrHn}</h5>
                          <p>
                            <div
                              className="l-footer__main__content__desAdr"
                              dangerouslySetInnerHTML={{
                                __html: trans.layout.address1,
                              }}
                            ></div>
                            <div className="mapView">
                              <a
                                className="link-btn"
                                target="_blank"
                                href="https://www.google.com/maps/place/Ng.+19+%C4%90.+Nguy%E1%BB%85n+Tr%C3%A3i,+Kh%C6%B0%C6%A1ng+Trung,+%C4%90%E1%BB%91ng+%C4%90a,+H%C3%A0+N%E1%BB%99i/@21.0022651,105.8203236,17z/data=!3m1!4b1!4m5!3m4!1s0x3135ac84f6869bf1:0xd2a5ff274402a0a0!8m2!3d21.0022651!4d105.8203236?hl=en"
                              >
                                Map view
                              </a>
                              <img src="/assets/img/home/arrowRight.svg" />
                            </div>
                          </p>
                        </div>
                        <div className="l-footer__main__content__item">
                          <h5>{trans.layout.adrHcm}</h5>
                          <p>
                            <div
                              className="l-footer__main__content__desAdr"
                              dangerouslySetInnerHTML={{
                                __html: trans.layout.address2,
                              }}
                            ></div>
                            <div className="mapView">
                              <a
                                className="link-btn"
                                target="_blank"
                                href="https://www.google.com/maps/place/102+Nguy%E1%BB%85n+%C4%90%C3%ACnh+Ch%C3%ADnh,+Ph%C6%B0%E1%BB%9Dng+15,+Ph%C3%BA+Nhu%E1%BA%ADn,+Th%C3%A0nh+ph%E1%BB%91+H%E1%BB%93+Ch%C3%AD+Minh,+Vi%E1%BB%87t+Nam/@10.7958593,106.6761517,17z/data=!3m1!4b1!4m5!3m4!1s0x317528d6786d52bf:0x77a4a2db8949796e!8m2!3d10.795854!4d106.6783404?hl=vi-VN"
                              >
                                Map view
                              </a>
                              <img src="/assets/img/home/arrowRight.svg" />
                            </div>
                          </p>
                        </div>
                        <div className="l-footer__main__content__item">
                          <h5>{trans.layout.adrJp}</h5>
                          <p>
                            <div
                              className="l-footer__main__content__desAdr"
                              dangerouslySetInnerHTML={{
                                __html: trans.layout.address3,
                              }}
                            ></div>
                            <div className="mapView">
                              <a
                                className="link-btn"
                                target="_blank"
                                href="https://www.google.co.jp/maps/place/THE+HUB+%E7%AB%8B%E5%B7%9D+nex+Inc./@35.6959613,139.4119304,17z/data=!3m2!4b1!5s0x6018e17b0d34626d:0x689d36f4af787ff0!4m5!3m4!1s0x6018e174c9931d8b:0x55275e3f4e298915!8m2!3d35.6959613!4d139.4119304"
                              >
                                Map view
                              </a>
                              <img src="/assets/img/home/arrowRight.svg" />
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="l-col-auto footer-col-menu l-footer__main__solution">
                      <h3 className="l-footer__main__title uppercase">
                        {trans.layout.solution}
                      </h3>
                      <div className="l-footer__main__content">
                        <ul>
                          {infor?.data?.solution?.rows &&
                            infor?.data?.solution?.rows?.map((item, index) => {
                              return (
                                <li>
                                  <Link href="https://eyefire.vn/solution">
                                    <a>
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: item?.title_footer,
                                        }}
                                      ></div>
                                    </a>
                                  </Link>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                      {/* <div className="l-footer__main__content__keep item-pc">
                        <h3
                          className="l-footer__main__title"
                         
                        >
                          {trans.layout.keep}
                        </h3>
                        <div className="l-footer__main__content__keep-item">
                          <ul>
                            <li>
                              <a
                                href="https://www.facebook.com/EyeFireCorp"
                                target="_blank"
                              >
                                <img
                                  src="/assets/img/common/icn_fb-footer.svg"
                                  alt=""
                                />
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <img
                                  src="/assets/img/common/icn_mes.svg"
                                  alt=""
                                />
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <img
                                  src="/assets/img/common/icn_sky.svg"
                                  alt=""
                                />
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <img
                                  src="/assets/img/common/icn_in.svg"
                                  alt=""
                                />
                              </a>
                            </li>
                            <li>
                              <a href="#">
                                <img
                                  src="/assets/img/common/icn_tw.svg"
                                  alt=""
                                />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div> */}
                    </div>
                    <div className="l-col-auto footer-col-menu l-footer__main__technology">
                      <h3 className="l-footer__main__title uppercase">
                        {trans.layout.technology}
                      </h3>
                      <div className="l-footer__main__content">
                        <ul>
                          {infor?.data?.feature_tech?.rows &&
                            infor?.data?.feature_tech?.rows.map(
                              (item, index) => {
                                return (
                                  <li>
                                    <Link href="https://eyefire.vn/technology">
                                      {item.title}
                                    </Link>
                                  </li>
                                );
                              },
                            )}
                        </ul>
                        {/* <div className="l-footer__main__content-rules item-pc">
                          <a href="#" className="l-footer__main__link">
                            {trans.layout.rule1}
                          </a>
                          <a href="#" className="l-footer__main__link">
                            {trans.layout.rule2}
                          </a>
                        </div> */}
                      </div>
                    </div>
                    <div className="l-col-auto footer-col-menu l-footer__main__menu ">
                      <h3 className="l-footer__main__title uppercase">
                        {trans.layout.menu}
                      </h3>
                      <div className="l-footer__main__content">
                        <ul>
                          <li>
                            <Link href="/">
                              <a target="_blank">{trans.layout.home}</a>
                            </Link>
                          </li>
                          <li>
                            <Link href="https://eyefire.vn/technology">
                              <a target="_blank">{trans.layout.technology}</a>
                            </Link>
                          </li>
                          <li>
                            <Link href="https://eyefire.vn/solution">
                              <a target="_blank">{trans.layout.solution}</a>
                            </Link>
                          </li>
                          <li>
                            <Link href="https://eyefire.vn/product">
                              <a target="_blank">{trans.layout.product}</a>
                            </Link>
                          </li>
                          <li>
                            <Link href="https://eyefire.vn/sdk">
                              <a target="_blank">{trans.layout.sdk}</a>
                            </Link>
                          </li>
                          <li>
                            <Link href="https://eyefire.vn/news">
                              <a target="_blank">{trans.layout.news}</a>
                            </Link>
                          </li>
                          <li>
                            <Link href="https://eyefire.vn/contact">
                              <a target="_blank">{trans.layout.contact}</a>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="l-footer__main__content__keep item-sp ">
                      <h3 className="l-footer__main__title">
                        {trans.layout.keep}
                      </h3>
                      <div className="l-footer__main__content__keep-item">
                        {/* <ul>
                          <li>
                            <a
                              href="https://www.facebook.com/EyeFireCorp"
                              target="_blank"
                            >
                              <img
                                src="/assets/img/common/icn_fb-footer.svg"
                                alt=""
                              />
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <img
                                src="/assets/img/common/icn_mes.svg"
                                alt=""
                              />
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <img
                                src="/assets/img/common/icn_sky.svg"
                                alt=""
                              />
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <img src="/assets/img/common/icn_in.svg" alt="" />
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <img src="/assets/img/common/icn_tw.svg" alt="" />
                            </a>
                          </li>
                        </ul> */}

                        <ul>
                          <li>
                            <a
                              href="https://www.facebook.com/TCOM.Corporation"
                              target={'_blank'}
                            >
                              <img
                                src="/assets/img/aiot/f.svg"
                                alt=""
                                className="fnaqljrqj2jqj2a"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://www.linkedin.com/company/tcom-corporation"
                              target={'_blank'}
                            >
                              <img
                                src="/assets/img/aiot/in.svg"
                                alt=""
                                className="fnaqljrqj2jqj2a"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="https://www.youtube.com/channel/UCmeadb8H2pD_05cFz0qvDVw"
                              target={'_blank'}
                            >
                              <img
                                src="/assets/img/aiot/y.svg"
                                alt=""
                                className="fnaqljrqj2jqj2a"
                              />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="l-footer__main__content-rules item-sp ">
                      <a href="#" className="l-footer__main__link">
                        {trans.term}
                      </a>
                      <a href="#" className="l-footer__main__link">
                        {trans.policy}
                      </a>
                    </div>
                  </div>
                  <div
                    className="l-row footer-pc rowTouchRule"
                    style={{ marginTop: '-3vw' }}
                  >
                    <div className="l-col-auto footer-col-menu l-footer__main__office"></div>
                    <div className="l-col-auto footer-col-menu l-footer__main__solution">
                      <div className="l-footer__main__content__keep item-pc">
                        <h3 className="l-footer__main__title">
                          {trans.layout.keep}
                        </h3>
                        <div className="l-footer__main__content__keep-item">
                          <ul>
                            <li>
                              <a
                                href="https://www.facebook.com/TCOM.Corporation"
                                target={'_blank'}
                              >
                                <img
                                  src="/assets/img/aiot/f.svg"
                                  alt=""
                                  className="fnaqljrqj2jqj2a"
                                />
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.linkedin.com/company/tcom-corporation"
                                target={'_blank'}
                              >
                                <img
                                  src="/assets/img/aiot/in.svg"
                                  alt=""
                                  className="fnaqljrqj2jqj2a"
                                />
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.youtube.com/channel/UCmeadb8H2pD_05cFz0qvDVw"
                                target={'_blank'}
                              >
                                <img
                                  src="/assets/img/aiot/y.svg"
                                  alt=""
                                  className="fnaqljrqj2jqj2a"
                                />
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="l-col-auto footer-col-menu l-footer__main__technology">
                      <div className="l-footer__main__content">
                        <div className="l-footer__main__content-rules item-pc">
                          <a href="#" className="l-footer__main__link">
                            {trans.term}
                          </a>
                          <a href="#" className="l-footer__main__link">
                            {trans.policy}
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      className="l-col-auto footer-col-menu l-footer__main__menu"
                      style={{ width: '375.23px' }}
                    ></div>
                  </div>
                </div>
              </div>

              <div className="l-footer__copyright">
                <div className="l-container-fluid">
                  <div className="l-footer__copyright__logo">
                    <img
                      src="/assets/img/common/icn_logo-copyright.svg"
                      alt=""
                    />
                  </div>
                  <p>{trans.layout.copyright}</p>
                  <div className="l-footer__copyright__logo l-footer__copyright__logo--right">
                    <img
                      src="/assets/img/aiot/bct.png"
                      alt=""
                      className="mvnqnqjfansnwnanfsfnas"
                    />
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>

      {/* end footer */}
    </>
  );
}
export default React.memo(Layout);
